import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="relative bg-stone-50 pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
      {/* Animated Background Orbs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <motion.div 
          animate={{ 
            scale: [1, 1.2, 1],
            x: [0, 50, 0],
            y: [0, 30, 0]
          }} 
          transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
          className="absolute -top-24 -left-24 w-96 h-96 bg-slate-200/50 rounded-full blur-3xl" 
        />
        <motion.div 
          animate={{ 
            scale: [1, 1.1, 1],
            x: [0, -30, 0],
            y: [0, 50, 0]
          }} 
          transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
          className="absolute top-1/2 -right-24 w-80 h-80 bg-stone-200/50 rounded-full blur-3xl" 
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-center">
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="lg:col-span-7 text-center lg:text-left"
          >
            <motion.span variants={itemVariants} className="text-slate-500 font-semibold tracking-[0.2em] uppercase text-xs mb-6 block">
              Digital Strateg & Leder
            </motion.span>
            <motion.h1 variants={itemVariants} className="text-5xl sm:text-6xl lg:text-7xl font-black text-slate-900 tracking-tight mb-8 leading-[1.1]">
              Digital ledelse, strategisk indhold og <span className="text-slate-400 font-light italic">sikker drift.</span>
            </motion.h1>
            <motion.p variants={itemVariants} className="text-xl text-slate-600 mb-12 max-w-2xl mx-auto lg:mx-0 leading-relaxed font-light">
              Jeg bygger bro mellem topledelsens visioner og redaktionens daglige arbejde. +20 års erfaring med at transformere og drive digitale medier.
            </motion.p>
            <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start">
              <a 
                href="#booking" 
                className="group relative inline-flex justify-center items-center px-10 py-5 text-base font-bold rounded-full text-white bg-slate-900 overflow-hidden transition-all duration-300 hover:pr-12"
              >
                <span className="relative z-10">Book et kaffemøde</span>
                <SafeIcon name="ArrowRight" className="absolute right-4 opacity-0 group-hover:opacity-100 group-hover:right-6 transition-all duration-300 h-5 w-5" />
              </a>
              <a 
                href="#erfaring" 
                className="inline-flex justify-center items-center px-10 py-5 text-base font-bold rounded-full text-slate-900 border-2 border-slate-200 hover:border-slate-900 transition-all duration-300"
              >
                Se min baggrund
              </a>
            </motion.div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9, rotate: -2 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mt-20 lg:mt-0 lg:col-span-5 relative"
          >
            <div className="relative group">
              <div className="absolute -inset-4 bg-slate-200 rounded-[2rem] transform rotate-3 group-hover:rotate-1 transition-transform duration-500"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] bg-slate-100">
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/9156b7ad9768dabbd1486a5021f9991fb512a0d6d6c844e6b5b41380a57b274ba7bc4b27b2a4de1f0a85d0c05b5620e1/images/aW1hZ2UvanBlZw==/a8bd613e7628d6e095fe304b06f88440.jpg" 
                  alt="Per Olkjær Nielsen" 
                  className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-700"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;